import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const HerzUltraschallPage = () => {
  return (
    <Layout>
      <PageHero
        title="Herz-Ultraschall (Echokardiographie): Blick in die Herzfunktion"
        subtitle="Wir visualisieren die Struktur und Funktion Ihres Herzens mit modernster Ultraschalltechnik."
        backgroundImage="/images/Kardiologie 4.webp"
        ctaText="Herz-Ultraschall buchen"
      />

      <ContentSection
        title="Das Herz unter dem Mikroskop"
        content="Die Echokardiographie ermöglicht uns, das schlagende Herz in Echtzeit darzustellen. Wir beurteilen die Größe der Herzkammern, die Funktion der Herzklappen, die Pumpkraft und erkennen krankhafte Veränderungen der Herzmuskulatur. Dies ist ein unverzichtbares Werkzeug zur Diagnostik vieler Herzerkrankungen."
        image="/images/Kardiologie 4.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Echokardiographie für Herzdiagnostik in Diez"
        content="In der Gemeinschaftspraxis Dres. von Bergh wird die Echokardiographie zur detaillierten Untersuchung der Herzfunktion eingesetzt."
      />

      <CTASection
        title="Lassen Sie die Funktion Ihres Herzens überprüfen"
        subtitle="Vereinbaren Sie einen Termin für den Herz-Ultraschall."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default HerzUltraschallPage;
